import React, { useState } from "react";
import { Col, Row } from "reactstrap";
import { withTranslation } from "react-i18next";
import CustomTable from "../../components/Common/CustomTable";
import useApi from "../../Hooks/useApi";
import {
  deleteSubDistributor,
  getSubDistributorList,
  updateSubDistributorStatus,
} from "../../helpers/API";
import useFilter from "../../Hooks/useFilter";
import { handleDelete, handleStatusChange } from "../../helpers/CommonAPICall";
import Add from "./Add";
import { MODAL_SIZES } from "../../components/ConfirmModal";
import { DATE_FORMAT } from "../../helpers/dateFormat";

const List = ({ t }) => {
  const [filters, setFilters] = useFilter({});
  const [state, setState] = useState({ id: "", operation: "", show: false });
  const [refresh, setRefresh] = useState(false);

  const [data, setData] = useApi({
    callback: getSubDistributorList,
    payload: filters,
    dependencies: [filters, refresh],
  });

  const handleClose = () => {
    setState(() => ({ id: "", operation: "", show: false }));
  };

  const columns = [
    {
      name: t("subDistributor.list.columns.name"),
      selector: (row) => (
        <>
          <td>
            {row?.profile ? (
              <img
                src={row?.profile}
                alt={t("subDistributor.list.alt.user")}
                className="avatar-xs rounded-circle"
              />
            ) : (
              <div className="avatar-xs">
                <span className="avatar-title rounded-circle bg-primary-subtle text-success">
                  {row.name.charAt(0)}
                </span>
              </div>
            )}
          </td>
          <td>
            <h5 className="font-size-15 mb-0 ps-1">{row.name}</h5>
          </td>
        </>
      ),
      sortable: true,
      sortField: "name",
    },
    {
      name: t("subDistributor.list.columns.email"),
      selector: (row) => row.email,
      sortField: "email",
      sortable: true,
    },
    {
      name: t("subDistributor.list.columns.mobileNumber"),
      selector: (row) => row.mobile,
    },
    {
      name: t("subDistributor.list.columns.status"),
      sortable: true,
      sortField: "isActive",
      isStatus: true,
      onClick: (data) => {
        handleStatusChange(
          data.id,
          { isActive: data.isActive },
          updateSubDistributorStatus,
          setData
        );
      },
    },
    {
      name: t("subDistributor.list.columns.createdDate"),
      dateField: "createdAt",
      sortable: true,
      sortField: "createdAt",
      dateFormat: DATE_FORMAT.DISPLAY,
    },
    {
      name: t("subDistributor.list.columns.updatedDate"),
      dateField: "updatedAt",
      sortable: true,
      sortField: "updatedAt",
      dateFormat: DATE_FORMAT.DISPLAY,
    },
    {
      name: t("subDistributor.list.columns.actions"),
      actionItems: [
        {
          label: t("subDistributor.list.actions.view"),
          icon: "ri-eye-fill ",
          className: "btn  btn-outline-primary",
          onClick: (data) => {
            setState({ id: data.id, operation: "view", show: true });
          },
        },
        {
          label: t("subDistributor.list.actions.edit"),
          icon: "ri-pencil-fill",
          className: "btn  btn-outline-success",
          onClick: (data) => {
            setState({
              id: data.id,
              operation: "edit",
              show: true,
            });
          },
        },
        {
          label: t("subDistributor.list.actions.delete"),
          icon: "ri-delete-bin-fill text-danger",
          className: "btn  btn-outline-danger",
          isConfirm: true,
          variant: "DELETE",
          size: MODAL_SIZES.MEDIUM,
          onClick: (data) => {
            handleDelete(data.id, deleteSubDistributor, setData);
          },
        },
      ],
    },
  ];

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <CustomTable
            columns={columns}
            data={data}
            buttonAction={() => {
              setState({ id: "", operation: "add", show: true });
            }}
            onStatusChange={(data) => setFilters(data)}
            searchKeys={["name", "email", "mobile"]}
            searchPlaceholder={t("subDistributor.list.search.placeholder")}
          />
        </Col>
      </Row>
      <Add state={state} handleClose={handleClose} refresh={setRefresh} />
    </React.Fragment>
  );
};

export default withTranslation()(List);
